module.exports = __webpack_public_path__ + "img/no-products.cf748464.svg";